import TimerSimulatedValueDisplay from './TimerSimulatedValueDisplay'

export default TimerSimulatedValueDisplay
